<div class="phone-call-alert-container">
    <div class="flex inbound-call-box gap-2 align-items-center mb-4 blink_me_1" *ngFor="let call of getCalls()">
        <img src="/assets/images/no-user-image.png" class="caller-image" />
        <div class="extension-number flex-grow-1">
            LLamada entrante de:
            <div *ngIf="call.fromName!=''"><b>{{ call.fromName }}</b></div>
            {{ call.from }}
            <div *ngIf="call.caseId!=''" class="extra-info">Expediente: <a (click)="goToCase(call.caseId)">{{ getCaseById(call.caseId)?.caseNumber }}</a></div>
        </div>
        <!--<p-button (click)="reject(call)" icon="pi pi-ban" severity="danger" [rounded]="true"></p-button>
        <p-button (click)="accept(call)" icon="pi pi-phone" severity="success"[rounded]="true"></p-button>-->
        <p-button *ngIf="call.caseId!=''" (click)="goToCase(call.caseId)" icon="pi pi-external-link" severity="success"[rounded]="true"></p-button>
    </div>
</div>